<template>
  <div 
    :id="blok.id" 
    :class="[
    'card-stat',
    {
      'card-stat--full-height': blok.full_height
    }
    ]" 
    :style="cardStyle">
    <div :class="cardClass" />
    <StoryblokComponent
      v-for="childBlok in blok.content"
      :key="childBlok._uid"
      :blok="childBlok"
    />
  </div>
</template>

<script setup lang="ts">
import type { SbCardStatStoryblok } from '@/types'

interface Props {
  blok: SbCardStatStoryblok
}

const props = defineProps<Props>()

const cardStyle = computed(() => {
  return {
    paddingLeft: `${props.blok?.padding_left}px`,
  }
})

const cardClass = computed(
  () => `card-stat__ornament--${props.blok.variant || 'bar'}`,
)
</script>

<style lang="scss" scoped>
.card-stat {
  position: relative;
 
  &--full-height {
    height: 100%;
  }

  &__ornament {
    content: '';
    position: absolute;
    top: 0;
    left: 0;

    &--bar {
      @extend .card-stat__ornament;

      width: 4px;
      height: 100%;
      background-color: var(--cobalt-800);
      border-radius: 10px;
    }

    &--thin-bar {
      @extend .card-stat__ornament--bar;

      width: 1px;
      background-color: var(--gray-400);
    }
    &--thin-violet-bar {
      @extend .card-stat__ornament--bar;

      width: 2px;
      background-color: var(--cobalt-300);
    }

    &--ribbon {
      @extend .card-stat__ornament;

      width: 32px;
      height: calc(100% - 8px);
      background-color: var(--violet-600);
      border-radius: 4px 4px 0 0;

      &::before {
        content: '';
        position: absolute;
        top: 16px;
        left: 9px;
        width: 14px;
        height: 13px;
        background-image: url('@/assets/icons/ribbon-star.svg');
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 32px;
        height: 8px;
        background-image: url('@/assets/icons/ribbon-ending.svg');
      }
    }
  }
}
</style>
